import { ChangeDetectionStrategy, Component, effect } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MdsDatepickerComponent } from '@medpacesoftwaredevelopment/designsystem';
import { ICellEditorParams } from '@medpacesoftwaredevelopment/designsystem/lib/components/ag-grid';
import { StudyExpenseTrackingDataRow } from '@models/studyExpenseTrackingDataRow';
import { maxDateValue, minDateValue } from '@utility/constants';
import { afterDateValidator, beforeDateValidator } from '@utility/utility.validators';
import { BaseCellEditorComponent } from '../base-cell-editor/base-cell-editor.component';

@Component({
    selector: 'medpace-custom-cell-editor-datepicker',
    imports: [MdsDatepickerComponent],
    standalone: true,
    templateUrl: './custom-cell-editor-datepicker.component.html',
    styleUrl: './custom-cell-editor-datepicker.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCellEditorDatepickerComponent<TContext = any> extends BaseCellEditorComponent<
    StudyExpenseTrackingDataRow,
    string,
    TContext,
    {
        min: Date;
        max: Date;
    }
> {
    override agInit(
        params: ICellEditorParams<StudyExpenseTrackingDataRow, string, TContext> & {
            min: Date;
            max: Date;
            format: string;
        }
    ): void {
        if (!params.max) params.max = maxDateValue;
        if (!params.min) params.min = minDateValue;

        super.agInit(params);
    }
    formControl = new FormControl<Date | null>(null, [
        afterDateValidator(minDateValue, `Date cannot be before ${minDateValue.toDateString()}`),
        beforeDateValidator(maxDateValue, `Date cannot be after ${maxDateValue.toDateString()}`),
    ]);
    setInitialValue = effect(() => {
        const baseParams = this.baseParams();
        if (!baseParams) return;
        this.formControl.setValue(new Date(baseParams.value));
    });

    getValue(): string {
        if (!this.formControl.valid || isNaN(this.formControl.value.getTime())) return '';
        return this.formControl.value.toISOString();
    }
    save() {
        this.baseParams().api.stopEditing(false);
    }
}
